import React, { memo } from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { SelectionToolbarPlugin } from '@atlaskit/editor-plugins/selection-toolbar';

import { CompanyHubBannerLoader } from '@confluence/company-hub/entry-points/CompanyHubBanner';
import {
	EditorControlsBannerLoader,
	LivePagesFeedbackBannerLoader,
	useIsControlsBannerDismissed,
} from '@confluence/editor-action-bar';
import type { TriggerAnalyticsEventType } from '@confluence/editor-features';

export type Props = {
	isLivePage: boolean;
	isEmbeddedConfluence: boolean;
	viewMode?: boolean;
	hasEditPermission: boolean;
	shouldRenderPagePreview: boolean;
	spaceKey: string;
	editorFullPagePresetAPI: PublicPluginAPI<[SelectionToolbarPlugin]> | undefined;
	triggerAnalyticsEvent?: TriggerAnalyticsEventType;
};

export const FullPageEditorBannerWrapper = memo(
	({
		isLivePage,
		isEmbeddedConfluence,
		viewMode,
		hasEditPermission,
		shouldRenderPagePreview,
		spaceKey,
		triggerAnalyticsEvent,
	}: Props) => {
		const { isControlsBannerDismissed, onDismiss, bannerType } =
			useIsControlsBannerDismissed(isLivePage);

		if (!viewMode && !isControlsBannerDismissed) {
			return (
				<EditorControlsBannerLoader
					onDismiss={onDismiss}
					triggerAnalyticsEvent={triggerAnalyticsEvent}
					isLivePage={isLivePage}
					isEmbeddedConfluence={isEmbeddedConfluence}
					bannerType={bannerType}
				/>
			);
		}

		if (isLivePage) {
			return <LivePagesFeedbackBannerLoader isViewOnly={viewMode && !hasEditPermission} />;
		} else {
			if (!shouldRenderPagePreview) {
				return <CompanyHubBannerLoader spaceKey={spaceKey} />;
			}
		}
	},
);
